/**
 * @documental
 * @export Underlined
 * @type
 * typographyComponent
 * @use
 * The `Underlined` component underlines the specified region of text.
 * @element
 * u
 * @className
 * underlined
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { createComponentStyleHook } from "../../tokens";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import tokenStyles from "./styles.module.css";

/**
 * The Underlined component properties.
 */

export interface UnderlinedProps extends BaseProps {}

const useResolvedUnderlinedStyles = createComponentStyleHook<UnderlinedProps>({
  legacyStyles: () => import("./styles.module.scss"),
  tokenStyles,
  componentTokens: "underlined",
});

/**
 * Specifies that text content should be displayed as underlined. Can be overridden
 * through the use of the [Strikethrough](../Strikethrough/README.md) component.
 */
export const Underlined: FC<PropsWithChildren<UnderlinedProps>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedUnderlinedStyles(props);
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Underlined, "underlined"] });

  return (
    <StyleModeBoundary mode={mode}>
      <u {...baseHtmlProps}>{children}</u>
    </StyleModeBoundary>
  );
};
